var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { attrs: { type: "flex", justify: "space-between" } },
    [
      _c("el-col", { attrs: { span: 4 } }, [
        _c("p", { staticClass: "title" }, [
          _c("strong", [_vm._v(_vm._s(_vm.label))]),
        ]),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.row.SE) } }),
      ]),
      _c("el-col", { attrs: { span: 6 } }, [
        _c("p", { staticClass: "title" }, [
          _c("strong", [_vm._v("Request Info")]),
        ]),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.row.RequestInfo) } }),
      ]),
      _c("el-col", { attrs: { span: 6 } }, [
        _c("p", { staticClass: "title" }, [_c("strong", [_vm._v("Notes")])]),
        _c("div", {
          staticClass: "expand-notes",
          domProps: { innerHTML: _vm._s(_vm.row.Notes) },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }